<template>
<tr>
	<td>
		<div class="form-group row mb-0" v-if="editing">
			<label class="col-4 col-form-label-sm">Name:</label>
			<input class="col-8 form-control form-control-sm" v-model="form.name" required>
		</div>
		<div class="form-group row mb-0" v-if="editing">
			<label class="col-4 col-form-label-sm">Category:</label>
			<input class="col-8 form-control form-control-sm" v-model="form.category" required>
		</div>
		<div class="text-right w-100" v-if="editing">
            <span class="btn btn-sm btn-ghost-danger mr-1" @click="deletePerm()">Delete</span>
            <span class="btn btn-sm btn-outline-secondary mr-1" @click="stopEditing()">Cancel</span>
            <span class="btn btn-sm btn-outline-primary" @click="savePerm()">Save</span>
		</div>						
		<a v-else href="#" @click.prevent.default="startEditing()">{{ perm.name }}</a>		
	</td>
	
	<td v-for="role in roles" class="text-center">
		<input v-if="editing" type="checkbox" :value="role.id" v-model="form.roles">

		<template v-else>
			<i v-if="roles_with_perm.includes(role.id)" class="fas fa-check-circle text-success"></i>
			<i v-else class="fas fa-minus text-gray-500"></i>
		</template>
	</td>

</tr>
</template>

<script>
	export default {
		props: ['perm', 'roles'],

		data() {
			return {
				editing: false,
				form: {},
			}
		},

		methods: {
            deletePerm() {
                this.$emit('delete_perm', this.perm.id);
            },

            savePerm() {
                axios.put('/api/permissions/' + this.perm.id, this.form).then(data => {
                    this.$emit('perm_saved');
                    this.editing = false;
                });
            },

			startEditing() {
				this.editing = true;
				this.form = {
					name: this.perm.name,
					category: this.perm.category,
					roles: this.roles_with_perm,
				}
			},

            stopEditing() {
                this.editing = false;
            }
		},

		computed: {
			roles_with_perm() {
				return this.perm.roles.map(role => role.id);
			}
		}
	}
</script>